export default __webpack_public_path__ + "static/media/cbs-dani.6b830127.jpeg";